import React from "react";

const ReductionOfShareCapital = () => {
  return <div>ReductionOfShareCapital</div>;
};

export default ReductionOfShareCapital;
